module.exports = __webpack_public_path__ + "static/img/Order_Ship@3x.4edc296e.png";